module.exports = (Promise.resolve(__parcel__require__("./" + "module.f993c913.f58d8bc6.js"))).then(() => parcelRequire('1MDW9'));